function routeName(route) {
  return String((route && route.name) || '').split('___')[0];
}

function catalogOpenedFromListing(to, from) {
  return routeName(to) === 'order-product-product' && ['index', 'order'].includes(routeName(from));
}

function catalogQueryPosition(to, from, savedPosition) {
  if (
    routeName(to) !== 'order' || routeName(from) !== 'order' ||
    to.path !== from.path || to.hash !== from.hash || to.fullPath === from.fullPath
  ) {
    return null;
  }
  return savedPosition || { x: 0, y: 0 };
}

let openedFromListing = false;

function rememberCatalogNavigation(to, from) {
  if (catalogOpenedFromListing(to, from)) {
    openedFromListing = true;
  } else if (routeName(to) !== 'order-product-product') {
    openedFromListing = false;
  }
  return openedFromListing;
}

function canBackToCatalog() {
  return openedFromListing;
}

module.exports = {
  routeName,
  catalogOpenedFromListing,
  catalogQueryPosition,
  rememberCatalogNavigation,
  canBackToCatalog,
};
